module.exports = __webpack_public_path__ + "static/user2-ae8cf70aaf9c926608139b9724d0e6f7.png";